import { gql } from '@apollo/client';

export const SIGN_IN = gql`
  mutation SignIn($input: SignInInput!) {
    signIn(input: $input) {
      accessToken
      refreshToken
      user {
        id
        email
        name
        surName
        rolActive
        concessionIDs
        teamIDs
        roles
        permissions
        validated
        userType

        # Multi-tenant fields
        activeTenantId
      }
      # Multi-tenant response fields (a nivel de Auth, no duplicado en user)
      availableTenants {
        tenantId
        tenantName
        roles
        rolActive
      }
    }
  }
`;

export const SWITCH_TENANT = gql`
  mutation SwitchTenant($input: SwitchTenantInput!) {
    switchTenant(input: $input) {
      accessToken
      refreshToken
      user {
        id
        email
        name
        surName
        rolActive
        concessionIDs
        teamIDs
        roles
        permissions
        validated
        userType

        # Multi-tenant fields
        activeTenantId
      }
      # Multi-tenant response fields (a nivel de Auth, no duplicado en user)
      availableTenants {
        tenantId
        tenantName
        roles
        rolActive
      }
    }
  }
`;

// Mutation para crear app-users (con email)
// TenantId se obtiene automáticamente del usuario autenticado en el backend
export const CREATE_APP_USER = gql`
  mutation CreateAppUser($input: NewAppUser!) {
    signUpAppUser(input: $input) {
      id
      email
      name
      surName
      rolActive
      concessionIDs
      teamIDs
      internal
      isActive
      userType
    }
  }
`;

// Mutation para crear operarios (sin email)
// TenantId se obtiene automáticamente del usuario autenticado en el backend
export const CREATE_OPERATOR = gql`
  mutation CreateOperator($input: NewOperator!) {
    signUpOperator(input: $input) {
      id
      email
      name
      surName
      rolActive
      concessionIDs
      teamIDs
      internal
      isActive
      userType
    }
  }
`;

export const UPDATE_USER_STATE = gql`
  mutation UpdateUserState($input: UpdateUser!) {
    updateUser(input: $input) {
      id
      email
      name
      surName
      roles
      rolActive
      permissions
      internal
      validated
      concessionIDs
      teamIDs
      isActive
      userType
    }
  }
`;

export const VALIDATE_USER = gql`
  mutation validateUser($input: ValidateUser!) {
    validateUser(input: $input) {
      validated
    }
  }
`;

export const REGENERATE_ACCESS_TOKEN = gql`
  mutation RegenerateAccessToken($refreshToken: ID!) {
    regenerateAccessToken(refreshToken: $refreshToken)
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($input: ForgotPasswordInput!) {
    forgotPassword(input: $input)
  }
`;

export const UPDATE_PASSWORD = gql`
  mutation UpdatePassword($input: UpdatePasswordInput!) {
    updatePassword(input: $input) {
      id
      email
      name
      surName
      validated
    }
  }
`;
